import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import type { RouterClient } from '@orpc/server';
import type { AppRouter } from '~/server/orpc/router';

/**
 * Client-side oRPC client for NFC app
 *
 * Calls are proxied through the local Nuxt server API endpoint.
 * Token refresh is handled automatically before each request.
 */
export default defineNuxtPlugin(() => {
  const { refresh } = useAuth();
  const config = useRuntimeConfig();

  // Build absolute URL for ORPC endpoint
  const baseUrl = config.public.appUrl || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');
  const orpcUrl = `${baseUrl}/api/orpc`;

  const fetcher = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    await refresh();
    const response = await fetch(input, {
      ...init,
      credentials: 'include',
    });

    return response;
  };

  const link = new RPCLink({
    url: orpcUrl,
    fetch: fetcher,
  });

  const client: RouterClient<AppRouter> = createORPCClient(link);

  return {
    provide: {
      orpc: client,
    },
  };
});
